<template>
  <div>
    <form
      ref="form"
      data-url="/qualityManagement/preparationCertificate/additionalData"
      :class="{ 'loading-opacity': preloader }"
      enctype="multipart/form-data"
    >
      <div class="row">
        <div class="col-12">
          <app-note
            class="mb-primary"
            :show-title="false"
            :notes="['Todos los campos con un (*) son obligatorios.']"
          />
        </div>
       
          <legend class="col-12 col-form-label text-primary pt-0 mb-3">
            <h5>Completar la siguiente información</h5>
          </legend>

        <div class="col-6">
          <div class="form-group">
            <label>Número de resolución <b class="text-danger">*</b></label>
            <app-input
              type="text"
              v-model="inputs.resolution_number"
              :required="true"
            />
          </div>
        </div>


        <!-- <div class="col-6">
          <div class="form-group">
            <label>Número de certifcado <b class="text-danger">*</b></label>
            <app-input
              type="text"
              v-model="inputs.certificate_number"
              :required="true"
            />
          </div>
        </div> -->
        <!-- <div class="col-6">
          <div class="form-group">
            <label>Descripción <b class="text-danger">*</b></label>
            <app-input
              type="text"
              v-model="inputs.accreditation_description"
              :required="true"
            />
          </div>
        </div> -->
        <!-- <div class="col-6">
          <div class="form-group">
            <label>Decisión de Acreditación <b class="text-danger">*</b></label>
            <app-input
              type="select"
              v-model="inputs.accreditation_decision"
              :required="true"
              :list="decisionList"
            />
          </div>
        </div> -->
        <div class="col-6">
          <div class="form-group">
            <label
              >Fecha de Resolución de Acreditación
              <b class="text-danger">*</b></label
            >
            <app-input
              :disabled="inputs.certificate_number"
              type="date"
              v-model="inputs.resolution_date"
              :required="true"
            />
            <small class="text-danger" v-if="inputs.certificate_number">
              No puede editar este campo por que ya tiene un código de certificado generado.
            </small>
          </div>
        </div>

        <div class="col-6" v-if="inputs.certificate_number">
          <div class="form-group">
            <label>Número de certifcado</label>
            <app-input
              :disabled="true"
              type="text"
              v-model="inputs.certificate_number"
              
            />
          </div>
        </div>

        <div class="col-6" v-if="inputs.acc_number">
          <div class="form-group">
            <label>Número de acreditación</label>
            <app-input
                type="text"
                v-model="inputs.acc_number"
                :disabled="true"
            />
          </div>
        </div>

        <div class="col-12">
          <div class="form-group">
            <label>Observación</label>
            <app-input
            class="mb-2"
            type="radio-buttons"
            v-model="cert.logo_sae"
            :list="confirm"
          />
            
          <quill-editor 
          v-if="cert.logo_sae"
          v-model="cert.footer1" 
          :options="editorOption" />
          </div>
        </div>

        <!-- <div class="col-6">
          <div class="form-group">
            <label>Condición de Alcance <b class="text-danger">*</b></label>
            <app-input
              type="select"
              v-model="inputs.condicion_scope"
              :required="true"
              :list="condicionList"
            />
          </div>
        </div> -->
        <!-- <div class="col-6">
          <div class="form-group">
            <label>Link del Alcance <b class="text-danger">*</b></label>
            <app-input
              type="text"
              v-model="inputs.accreditation_link"
              :required="true"
            />
          </div>
        </div> -->
        <!-- <div class="col-6">
          <div class="form-group">
            <label>Id_campo de acreditación <b class="text-danger">*</b></label>
            <app-input
              type="select"
              v-model="inputs.accreditation_field"
              :required="true"
              :list="fieldList"
            />
          </div>
        </div> -->
      </div>
      <div class="space-quill" v-if="cert.logo_sae"></div>
      <div class="row">
        <div class="col-12 mt-2">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
    <!-- <div>
      <div class="row">
        <div class="col-12">
          <app-note
            class="mb-primary"
            :show-title="false"
            :notes="[
              'Una vez llenada la información anterior podrá generar el archivo excel.',
            ]"
          />
        </div>
        <div class="col-12">
          <button
            type="button"
            class="btn btn-success btn-with-shadow"
            data-toggle="modal"
            @click="openTab('excel')"
          >
            Generar Excel
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";
import { quillEditor } from "vue-quill-editor";

export default {
  mixins: [FormMixin],
  components: { quillEditor },

  data() {
    return {
      preloader: false,
      inputs: "",
      cert: {},
      decisionList: [

      ],

      condicionList: [
        { id: "", value: "Selecciona una opción" },
        { id: "Activo", value: "Activo" },
        { id: "Ampliado", value: "Ampliado" },
        { id: "Mantener", value: "Mantener" },
        { id: "Reducir alcance", value: "Reducir alcance" },
        { id: "Retirado", value: "Retirado" },
        { id: "Retiro voluntario", value: "Retiro voluntario" },
        { id: "Suspendido", value: "Suspendido" },
        { id: "Suspención voluntaria", value: "Suspención voluntaria" },
      ],

      fieldList: [
        { id: "", value: "Selecciona una opción" },
        { id: "EN-001", value: "EN-001" },
        { id: "EN-002", value: "EN-002" },
      ],
      confirm: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },

  created() {
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    data() {
      let url = `${actions.QUALITY_MANAGEMENT}/preparationCertificate/show?accAppId=${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
        if(response.data.resolution_date) {
          let date = new Date(response.data.resolution_date);
          date.setDate(date.getDate() + 1);
          this.inputs.resolution_date = date;
        } else {
          this.inputs.resolution_date = new Date();
        }

          let urlCertificate = `${actions.QUALITY_MANAGEMENT}/preparationCertificate/showCertificate/${response.data.accreditation_activity_id}`;
          this.axiosGet(urlCertificate).then((response) => {
          this.cert = response.data;
        })
      });

      let urlResolutionList = '/resolutionList';
      this.axiosGet(urlResolutionList).then((response)=>{
        this.decisionList = response.data;
      })

    },

    submit() {
      var dateString = moment(this.inputs.resolution_date).format("YYYY-MM-DD");
      var tmp = "";
      tmp = this.inputs;
      tmp.resolution_date = dateString;
      let formData = new FormData();
      for (const [key, value] of Object.entries(tmp)) {
        formData.append(key, value);
      }
      formData.append("observation", this.cert.logo_sae);
      formData.append("observationmsg", this.cert.footer1);
      this.save(formData);
    },
    afterSuccess({ data: { data } }) {
      this.inputs = data;
      if(data.resolution_date) {
          let date = new Date(data.resolution_date);
          date.setDate(date.getDate() + 1);
          this.inputs.resolution_date = date;
        }
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    openTab(type) {
      const url = `/common/scopes/exportFinal?type=${type}&accAppId=${this.$store.state.accreditation.id}`;
      window.open(url,  "_blank").focus();
    },
  },
};
</script>
<style>
.space-quill {
  margin-top: 140px;
}
</style>
